"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxIconButtonDelete'
};
var useStyles = (0, _styles.makeStyles)({
  root: {}
}, themeSettings);

var _ref2 = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Warning.default, {
  color: "error"
}));

var _ref3 = /*#__PURE__*/_react.default.createElement(_Delete.default, null);

var IconButtonDelete = function IconButtonDelete(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "disabled", "onClick", "style"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var handleConfirmed = _react.default.useCallback(function (event) {
    if (clicked) {
      clearTimeout(clicked);
      var res = onClick ? onClick(event) : undefined;

      if (res && res.then) {
        res.then(function (x) {
          setClicked(null);
          return x;
        }, function (err) {
          setClicked(null);
          throw err;
        });
      } else {
        setClicked(null);
      }
    }
  }, [clicked, onClick]);

  var handleButtonClick = _react.default.useCallback(function (event) {
    if (!clicked) {
      setClicked(setTimeout(function () {
        setClicked(null);
      }, 4000));
      return;
    }

    handleConfirmed(event);
  }, [clicked, handleConfirmed]);

  var handleClickOutside = _react.default.useCallback(function ()
  /* event */
  {
    if (clicked) {
      setClicked(null);
    }
  }, [clicked]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    mouseEvent: "onMouseDown",
    touchEvent: "onTouchStart",
    onClickAway: function onClickAway() {
      return handleClickOutside();
    }
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    disabled: disabled,
    onClick: handleButtonClick
  }, rest), clicked ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('app/actions/removeConfirmation'),
    open: true,
    placement: "left"
  }, _ref2) : _ref3)));
};

process.env.NODE_ENV !== "production" ? IconButtonDelete.propTypes = {
  onClick: _propTypes.default.func
} : void 0;
IconButtonDelete.displayName = 'IconButtonDelete';

var _default = (0, _withThemeProps.default)(themeSettings)(IconButtonDelete);

exports.default = _default;